export default {
  // Endpoints
  // registerEndpoint: '/jwt/register',
  // refreshEndpoint: '/jwt/refresh-token',
  // logoutEndpoint: '/jwt/logout',
  registerEndpoint: '/api/auth/register',
  refreshEndpoint: 'auth/token/refresh/',
  logoutEndpoint: '/jwt/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  storageTokenKeyName: 'token',
  storageRefreshTokenKeyName: 'refresh_token',
  storageUserDataKeyName: 'user',
}
